import { FacilityInfoRow } from "../externalStorageFacility.types";
import FacilityViewInfoSection from "./FacilityViewInfoSection";

interface FacilityViewOriginalPanelProps {
  rows: FacilityInfoRow[];
}

const FacilityViewOriginalPanel = ({ rows }: FacilityViewOriginalPanelProps) => {
  if (!rows.length) {
    return null;
  }

  return (
    <div className="tw-rounded-lg tw-border tw-border-border tw-bg-secondary/20 tw-p-4 tw-space-y-3">
      <p className="tw-text-sm tw-font-semibold tw-text-foreground">Original facility data</p>
      <FacilityViewInfoSection rows={rows} />
    </div>
  );
};

export default FacilityViewOriginalPanel;
